import {
  BookOutlined,
  BellOutlined,
  ContactsOutlined,
  FileImageOutlined,
  PullRequestOutlined,
  SettingOutlined,
  UserOutlined,
} from '@ant-design/icons';

const notificationsResource = {
  name: 'notifications',
  list: '/notifications',
  meta: {
    canDelete: false,
    icon: <BellOutlined />,
    canCreate: false,
  },
};

export const resources = [
  {
    name: 'listing-users',
    list: '/',
    show: '/:id',
    meta: {
      canDelete: true,
      icon: <UserOutlined />,
      canCreate: false,
    },
  },
  {
    name: 'listing-topics',
    list: '/topics',
    meta: {
      canDelete: true,
      icon: <BookOutlined />,
      canCreate: false,
    },
  },
  {
    name: 'listing-admins',
    list: '/admins',
    meta: {
      canDelete: true,
      icon: <UserOutlined />,
      canCreate: false,
      canShow: true,
    },
  },
  {
    name: 'listing-classes',
    list: '/classes',
    create: '/classes/create',
    show: '/classes/:id',
    edit: '/classes/:id/edit',
    meta: {
      canDelete: true,
      icon: <BookOutlined />,
      canCreate: true,
      canShow: true,
      canEdit: true,
    },
  },
  {
    name: 'listing-request',
    list: '/listing-request',
    show: '/listing-request/showPostReq/:id/:reqId',
    meta: {
      canDelete: false,
      icon: <PullRequestOutlined />,
      canCreate: false,
      canShow: true,
    },
  },
  {
    name: 'listing-posts',
    list: '/posts',
    show: '/posts/:id',
    meta: {
      canDelete: false,
      icon: <FileImageOutlined />,
      canCreate: false,
    },
  },
  {
    name: 'listing-contact-us',
    list: '/contact-us',
    show: '/contact-us/:id',
    meta: {
      canDelete: false,
      icon: <ContactsOutlined />,
      canCreate: false,
    },
  },
  {
    name: 'system-config',
    list: '/system-config',
    meta: {
      canDelete: true,
      icon: <SettingOutlined />,
      canCreate: true,
    },
  },
  notificationsResource,
];
export const academicSupervisorProgramHead = [
  {
    name: 'listing-topics',
    list: '/topics',
    meta: {
      canDelete: true,
      icon: <BookOutlined />,
    },
  },
  {
    name: 'listing-request',
    list: '/listing-request',
    show: '/listing-request/showPostReq/:id/:reqId',
    meta: {
      canDelete: false,
      icon: <PullRequestOutlined />,
      canCreate: false,
      canShow: true,
    },
  },
  {
    name: 'listing-posts',
    list: '/posts',
    show: '/posts/:id',
    meta: {
      canDelete: false,
      icon: <FileImageOutlined />,
      canCreate: false,
    },
  },
  notificationsResource,
];
export const systemAdminResources = [
  {
    name: 'listing-topics',
    list: '/topics',
    meta: {
      canDelete: true,
      icon: <BookOutlined />,
    },
  },
  {
    name: 'listing-request',
    list: '/listing-request',
    show: '/listing-request/showPostReq/:id/:reqId',
    meta: {
      canDelete: false,
      icon: <PullRequestOutlined />,
      canCreate: false,
      canShow: true,
    },
  },
  {
    name: 'listing-posts',
    list: '/posts',
    show: '/posts/:id',
    meta: {
      canDelete: false,
      icon: <FileImageOutlined />,
      canCreate: false,
    },
  },
  notificationsResource,
];
